<template>
  <el-select
    v-model="selectedValue"
    placeholder="请选择"
    style="width: 100%"
    clearable
    filterable
    :disabled="disabled"
    @change="select"
  >
    <el-option
      v-for="item in options"
      :key="item.Id"
      :label="`${item.PB_StorArea?.Name}/${item.PB_Rack?.Name}/${item.Name}`"
      :value="item.Id"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  name: "ShelfSelect",
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedValue: this.value,
      options: [],
    };
  },
  watch: {
    selectedValue(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      this.selectedValue = newValue;
    },
  },
  created() {
    this.fetchOptions();
  },
  methods: {
    select(value) {
      console.log(value);
      let obj = this.options.find((item) => {
        return item.Id == value;
      });
      this.$emit("select", obj);
    },
    async fetchOptions() {
      try {
        await this.$http.post("/PB/PB_Location/GetDataList", {}).then((res) => {
          if (res.Success) {
            this.options = res.Data;
          } else {
            this.options = [];
          }
        });
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    },
  },
};
</script>
